import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0001 3.33317C6.31818 3.33317 3.33341 6.31794 3.33341 9.99984C3.33341 13.6818 6.31818 16.6665 10.0001 16.6665C13.682 16.6665 16.6667 13.6818 16.6667 9.99984C16.6667 6.31794 13.682 3.33317 10.0001 3.33317ZM1.66675 9.99984C1.66675 5.39746 5.39771 1.6665 10.0001 1.6665C14.6024 1.6665 18.3334 5.39746 18.3334 9.99984C18.3334 14.6022 14.6024 18.3332 10.0001 18.3332C5.39771 18.3332 1.66675 14.6022 1.66675 9.99984Z"
            fill={ds.colorValue.icon.brand}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0001 7.50016C9.68567 7.50016 9.41058 7.674 9.268 7.93476C9.04708 8.33858 8.54075 8.48683 8.13697 8.26599C7.73318 8.04513 7.58489 7.53876 7.80574 7.13498C8.22894 6.36125 9.05225 5.8335 10.0001 5.8335C11.2623 5.8335 12.1392 6.67219 12.3887 7.65766C12.6397 8.64841 12.2585 9.80266 11.1181 10.3728C10.9437 10.4601 10.8334 10.6384 10.8334 10.8335C10.8334 11.2937 10.4603 11.6668 10.0001 11.6668C9.53983 11.6668 9.16675 11.2937 9.16675 10.8335C9.16675 10.0072 9.63367 9.25166 10.3727 8.88216C10.7517 8.69266 10.8491 8.36658 10.7732 8.06691C10.6959 7.76197 10.4403 7.50016 10.0001 7.50016Z"
            fill={ds.colorValue.icon.brand}
        />
        <Path
            d="M10.9171 13.3332C10.9171 13.8394 10.5067 14.2498 10.0004 14.2498C9.49416 14.2498 9.08374 13.8394 9.08374 13.3332C9.08374 12.8269 9.49416 12.4165 10.0004 12.4165C10.5067 12.4165 10.9171 12.8269 10.9171 13.3332Z"
            fill={ds.colorValue.icon.brand}
        />
    </Svg>
);

export default SvgComponent;
